import React from 'react';
import Cookies from 'universal-cookie';
import CircularProgress from "@material-ui/core/CircularProgress";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { get } from '../../../../../../controllers/scorecard';
import Filter from "../../../../../util/filter/.mixins/Filter";
import Error from "../../../../../util/error/.mixins/Error";
// import { Paper, Typography} from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { AuthContext } from '../../../../../../contexts/AuthContext';
// import TagManager from 'react-gtm-module';

class Scorecard extends React.Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.permissions = {};

        this.state = {
            isLoading: true,
            isError: false,
            error: null,
            reportId: null,
            embedUrl: null,
            accessToken: null,
            filters: {
                datas: false,
                flagsPag: false,
                adminFilter: false,
            },
            fornecedor: 0,
        };

        this.loadData = this.loadData.bind(this);
        this.setState = this.setState.bind(this);
    }

    componentWillMount() {
        this.permissions = this.context.user.permissions;
        
        this.setState({
            filters: {
                ...this.state.filters,
                adminFilter: !!this.permissions["admin-scorecard"],
            }
        });
    }
    
    async componentDidMount() {
        this.loadData(null);

        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:scorecard',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-scorecard',
        //     }
        // });
    }

    async loadData(datas) {
        try {
            const cookies = new Cookies();
            const token = cookies.get('User-Token');
            this.setState({isLoading: true});
            const o_powerbi = await get(token, this.state.fornecedor);
            const j_powerbi = JSON.parse(o_powerbi.res.body);
            if (o_powerbi.res.statusCode == 200) {
                this.setState({
                    reportId: j_powerbi.EmbedReport[0].ReportId,
                    embedUrl: j_powerbi.EmbedReport[0].EmbedUrl,
                    accessToken: j_powerbi.EmbedToken.Token,
                    isLoading: false
                });
            }
            this.setState({isLoading: false});
            
            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:scorecard',
            //       eventAction: 'callback',
            //       eventLabel: 'sucesso',
            //     }
            // });
        } catch (error) {
            this.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });
            
            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:scorecard',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    }

    render() {
        return (
            <>

            <Helmet>
                <title>{`${process.env.REACT_APP_TITLE} - Scorecard`}</title>
            </Helmet>

            {this.state.filters.adminFilter &&
                <Filter {...this}/>
            }

            {this.state.isLoading &&
                <div align="center">
                    <br/>
                    <CircularProgress/>
                </div>
            }
            {!this.state.isLoading &&
                <>
                    <PowerBIEmbed
                        embedConfig = {{
                            type: 'report',
                            id: this.state.reportId,
                            embedUrl: this.state.embedUrl,
                            accessToken: this.state.accessToken,
                            tokenType: models.TokenType.Embed,
                            settings: {
                                panes: {
                                    filters: {
                                        expanded: false,
                                        visible: false
                                    }
                                },
                                background: models.BackgroundType.Transparent,
                            }
                        }}

                        eventHandlers = { 
                            new Map([
                                ['loaded', function () {console.log('Report loaded');}],
                                ['rendered', function () {console.log('Report rendered');}],
                                ['error', function (event) {console.log(event.detail);}]
                            ])
                        }
                            
                        cssClassName = { "report-style-class" }

                        getEmbeddedComponent = { (embeddedReport) => {
                            this.report = embeddedReport;
                        }}
                    />
                </>
            }

            {this.state.isError &&
            <div align="center">
                <Error text={this.state.error}/>
            </div>
            }

            </>
        );
    }

};

export default Scorecard;